import axios from "axios";
import { getItem } from "./LocalStorageManager";
import jwt_decode from "jwt-decode";
import Url from "../urls/Url";
/**
 * Axion public
 */
const publicFetch = axios.create({
  baseURL: Url.base_url + Url.api_context,
});

/**
 * Axion private - internal parval endpoints
 */
const privateFetch = axios.create({
  baseURL: Url.base_url + Url.api_context,
});

/**
 * Axion private - interceptors
 */
privateFetch.interceptors.request.use(
  async (config) => {
    //validate uri to send token
    const { origin } = new URL(config.baseURL + config.url);
    //console.log("origin: ", origin);
    const allowedOrigins = [Url.base_url];
    //console.log(allowedOrigins);
    const authInfo = await getItem("authDUEClientInfo");
    const decodeToken = jwt_decode(authInfo?.tokenInfo?.access_token);
    const expiresAt = decodeToken.exp;
    let valid = new Date().getTime() / 1000 < expiresAt;
    //console.log(allowedOrigins.includes(origin));

    if (allowedOrigins.includes(origin) && valid) {
      config.headers.Authorization = `Bearer ${authInfo?.tokenInfo?.access_token}`;
    }
    return config;
  }
  // error=>{
  //   return Promise.reject(error);
  // }
);

export { publicFetch, privateFetch };
